import { useMemo as o } from "../../../external/preact/hooks/dist/hooks.module.js";
import u from "../../../core/Context/useCoreContext.js";
import { uuid as n } from "../../../utils/random/uuid.js";
const p = (r) => {
  const { i18n: t } = u();
  return o(() => r.map((e) => ({
    key: e.key,
    value: e.value,
    id: n(),
    label: t.get(e.key)
  })), [t, r]);
};
export {
  p as useStructuredListItems
};
